import { render } from "./HistoryActionList.vue?vue&type=template&id=6738467d"
import script from "./HistoryActionList.vue?vue&type=script&lang=js"
export * from "./HistoryActionList.vue?vue&type=script&lang=js"
script.render = render

export default script